import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-crumbs",
  "use": "icon-crumbs-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-crumbs\"><defs><style></style></defs><path d=\"M28.45 113.78h967.11v113.78H28.45V113.78zm0 341.33h967.11v113.78H28.45V455.11zm0 341.33h967.11v113.78H28.45V796.44z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol